export default __webpack_public_path__ + "static/media/van.6a33d44c.svg";